import { validateCPF } from 'utils/validation/validators'

type ValidateCPFOnCustomFormParams = {
  cpf: string
  isRequired?: boolean
}

export default function validateCPFOnCustomForm({ cpf, isRequired }: ValidateCPFOnCustomFormParams) {
  const cpfValue = Array.isArray(cpf) ? cpf[0] : cpf
  let error = ''
  if (isRequired && cpfValue === '') {
    error = 'Este campo é obrigatório'
  }
  if (cpfValue && !validateCPF(cpfValue)) {
    error = 'Este CPF está incorreto.'
  }
  return error
}
